import { LIST_FOLDER_LOGS, LIST_LOGS, VIEW_LOG } from "../../constant";
import { resourceRequest } from "../calls";

export function doListLogs(token, data) {
  return resourceRequest(token, LIST_LOGS, data);
}

export function doListFolderLogs(token, data) {
  return resourceRequest(token, LIST_FOLDER_LOGS, data);
}

export function doViewLog(token, data) {
  return resourceRequest(token, VIEW_LOG, data);
}
